// KpiTile — one clickable metric card in the group KPI bar (Ship 3).
//
// A plain <button> so it's keyboard-focusable and clickable into the
// drill-down. NO aria-label: the visible child text (label + value +
// subtitle) is the accessible name. Adding an aria-label here would
// override that child text and make the numbers inaudible to screen
// readers (known a11y incident).
//
// tone drives the value color (used by Labor %): 'green' | 'yellow' |
// 'red' | 'neutral'. Default 'neutral'.

const TONE_TEXT = {
  green:   'text-emerald-700',
  yellow:  'text-amber-700',
  red:     'text-red-700',
  neutral: 'text-black/85',
}

export default function KpiTile({ label, value, sub, tone = 'neutral', onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex min-w-0 flex-1 flex-col rounded-xl border border-black/10 bg-white px-3 py-2.5 text-left shadow-sm transition hover:border-black/20 hover:bg-blue-50/40 focus:outline-none focus:ring-2 focus:ring-blue-500/40"
    >
      <span className="truncate text-[10px] font-medium uppercase tracking-wide text-black/55">
        {label}
      </span>
      <span className={`mt-0.5 truncate text-lg font-semibold tabular-nums ${TONE_TEXT[tone] || TONE_TEXT.neutral}`}>
        {value}
      </span>
      {sub != null && sub !== '' && (
        <span className="mt-0.5 truncate text-[11px] text-black/55 tabular-nums">
          {sub}
        </span>
      )}
    </button>
  )
}
